import React, { FC } from 'react';

import styled from '@emotion/styled';

import Heading, { HeadingProps } from '../heading/heading';

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface CardTitleProps extends HeadingProps {}

const StyledCardTitle = styled(Heading)<CardTitleProps>({
  label: 'cardTitle'
});

const CardTitle: FC<CardTitleProps> = (props) => (
  <StyledCardTitle {...props} />
);

export { CardTitle };
export default CardTitle;
